import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { HpiEligibilityFlow } from 'src/shared/models/shared';
import { useHpiEligibilityFlow } from '../hooks/useHpiEligibilityFlow';
import { useSelector } from 'react-redux';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';
import InsuranceController from '../controllers/InsuranceController';
import { InsurancePageName } from '../helpers/insuranceHelpers';
import { BodyTextMedium } from '@modernhealth/vital-components';
import styled from '@emotion/styled';

type Props = RouteComponentProps<
    {},
    {},
    { routedFromProfilePage?: boolean; hpiEligibilityFlow?: HpiEligibilityFlow }
>;

const DescriptionText = styled(BodyTextMedium)({
    alignSelf: 'flex-start',
});

const getDescription = (hpiEligibilityFlow: HpiEligibilityFlow, t) => {
    let descriptionOne: string, descriptionTwo: string;
    switch (hpiEligibilityFlow) {
        case HpiEligibilityFlow.Psychiatry:
            descriptionOne = t('insuranceForm:insurance_inactive.pamm.description_one');
            descriptionTwo = t('insuranceForm:insurance_inactive.pamm.description_two');
            break;
        case HpiEligibilityFlow.Therapy:
        default:
            descriptionOne = t('insuranceForm:insurance_inactive.description_one');
            descriptionTwo = t('insuranceForm:insurance_inactive.description_two');
            break;
    }
    return { descriptionOne, descriptionTwo };
};

export const InsuranceInactivePage: FC<Props> = ({ location }) => {
    const { t } = useTranslation();

    const hpiEligibilityFlow = useHpiEligibilityFlow();

    // using state hooks to ensure hpiEligibilityFlow is first collected before rendering
    const [descriptionText] = useState(getDescription(hpiEligibilityFlow, t));

    const user = useSelector(getUserInformation);

    if (!user.isCompanyHpiEnabled) {
        return <Redirect to="/dashboard" />;
    }

    return (
        <InsuranceController page={InsurancePageName.InsuranceInactive} location={location}>
            <DescriptionText fontColor="gray65" marginTop={10}>
                {descriptionText.descriptionOne}
            </DescriptionText>
            <DescriptionText fontColor="gray65" marginTop={24}>
                {descriptionText.descriptionTwo}
            </DescriptionText>
        </InsuranceController>
    );
};
